import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { encode } from '../../../helpers/queryEncryption';
import { api, categoryUploadDir } from '../../../config';
import s from './CategoryItem.css';

export class CategoryItem extends Component {

    handleClick = () => {
        const { categoryId } = this.props;
        return { redirect: `/category?type=${encodeURIComponent(encode(categoryId?.toString()))}` }
    }

    render() {
        const { categoryName, categoryLogo } = this.props;

        return (
            <div onClick={this.handleClick} className={s.allCategoryListItemBox}>
                <div className={s.allCategoryListItemImgContainer}>
                    <div className={s.allCategoryListItemImgWrapper}>
                        <img
                            src={`${api.apiEndpoint}${categoryUploadDir}medium_${categoryLogo}`}
                        />
                    </div>
                </div>
                <div className={s.allCategoryListItemInfo}>
                    {categoryName}
                </div>
            </div>
        )
    }
}

export default compose(withStyles(s))(CategoryItem);
